export const getCertExtension = (cert) => {
  if (!cert) return "";
  const urlOrName = cert.file_url || cert.file_name || cert.title || "";
  if (urlOrName) {
    const pathWithoutQuery = urlOrName.split("?")[0];
    const lastDot = pathWithoutQuery.lastIndexOf(".");
    if (lastDot !== -1 && lastDot < pathWithoutQuery.length - 1) {
      const ext = pathWithoutQuery.substring(lastDot + 1).toLowerCase().trim();
      if (ext && ext !== "image") {
        return ext;
      }
    }
  }
  if (cert.file_extension && typeof cert.file_extension === "string") {
    return cert.file_extension.toLowerCase().trim().replace(/^\./, "");
  }
  return "";
};

export const isImageFile = (cert) => {
  if (!cert) return false;
  if (
    cert.extension_type === "image" ||
    cert.file_type === "image" ||
    (typeof cert.file_extension === "string" && cert.file_extension.toLowerCase().trim() === "image")
  ) {
    return true;
  }
  const ext = getCertExtension(cert);
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp", "avif", "image"];
  if (imageExtensions.includes(ext)) return true;

  const urlOrName = cert.file_url || cert.file_name || cert.title || "";
  if (urlOrName) {
    const pathWithoutQuery = urlOrName.split("?")[0];
    const lastDot = pathWithoutQuery.lastIndexOf(".");
    if (lastDot !== -1 && lastDot < pathWithoutQuery.length - 1) {
      const parsedExt = pathWithoutQuery.substring(lastDot + 1).toLowerCase().trim();
      if (imageExtensions.includes(parsedExt)) return true;
    }
  }

  return false;
};

export const getDocumentIconDetails = (cert) => {
  const ext = getCertExtension(cert);
  if (["pdf"].includes(ext)) {
    return { icon: "bx bxs-file-pdf", color: "#ef4444", label: "PDF", bg: "#fef2f2" };
  }
  if (["doc", "docx"].includes(ext)) {
    return { icon: "bx bxs-file-doc", color: "#2563eb", label: "DOC", bg: "#eff6ff" };
  }
  if (["xls", "xlsx", "csv"].includes(ext)) {
    return { icon: "bx bxs-file", color: "#10b981", label: "EXCEL", bg: "#ecfdf5" };
  }
  if (["ppt", "pptx"].includes(ext)) {
    return { icon: "bx bxs-file", color: "#f97316", label: "PPT", bg: "#fff7ed" };
  }
  if (["zip", "rar", "7z", "tar", "gz"].includes(ext)) {
    return { icon: "bx bxs-file-archive", color: "#8b5cf6", label: "ZIP", bg: "#f5f3ff" };
  }
  if (["txt", "rtf", "md"].includes(ext)) {
    return { icon: "bx bxs-file-txt", color: "#64748b", label: "TXT", bg: "#f8fafc" };
  }
  if (["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp", "avif", "image"].includes(ext) || isImageFile(cert)) {
    return { icon: "bx bxs-file-image", color: "#3b82f6", label: "IMAGE", bg: "#eff6ff" };
  }
  return { icon: "bx bxs-file-blank", color: "#64748b", label: ext && ext !== "image" ? ext.toUpperCase() : "DOC", bg: "#f8fafc" };
};

